export default __webpack_public_path__ + "500error.png";